// removed by extract-text-webpack-plugin
module.exports = {"wasabi-button":"wasabi-button","size-large":"size-large","size-default":"size-default","size-small":"size-small","primary":"primary","default":"default","success":"success","info":"info","warning":"warning","danger":"danger","cancel":"cancel","green":"green"};


//////////////////
// WEBPACK FOOTER
// ./~/wasabiD/Sass/Buttons/button.scss
// module id = 162
// module chunks = 0